import { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { BucketIdField } from '@/pages/instruments/new-instrument/form-fields/BucketIdField'
import { CashSettlementDateField } from '@/pages/instruments/new-instrument/form-fields/CashSettlementDateField'
import { CounterpartyIdField } from '@/pages/instruments/new-instrument/form-fields/CounterpartyIdField'
import { CurrencyIdField } from '@/pages/instruments/new-instrument/form-fields/CurrencyIdField'
import { EffectiveDateFormField } from '@/pages/instruments/new-instrument/form-fields/EffectiveDateFormField'
import { FirstFloaterSettlementDateField } from '@/pages/instruments/new-instrument/form-fields/FirstFloaterSettlementDateField'
import { FloaterSpreadBpsField } from '@/pages/instruments/new-instrument/form-fields/FloaterSpreadBpsField'
import { FundIdField } from '@/pages/instruments/new-instrument/form-fields/FundIdField'
import { FundedReturnTypeField } from '@/pages/instruments/new-instrument/form-fields/FundedReturnTypeField'
import { FundingInstrumentFormField } from '@/pages/instruments/new-instrument/form-fields/FundingInstrumentFormField'
import { FundingReturnTypeField } from '@/pages/instruments/new-instrument/form-fields/FundingReturnTypeField'
import { InstrumentIdByTypeInput } from '@/pages/instruments/new-instrument/form-fields/InstrumentIdByTypeInput'
import { LeverageField } from '@/pages/instruments/new-instrument/form-fields/LeverageField'
import { MaturityDateField } from '@/pages/instruments/new-instrument/form-fields/MaturityDateField'
import { NotionalField } from '@/pages/instruments/new-instrument/form-fields/NotionalField'
import { PenultimateFloaterSettlementDateField } from '@/pages/instruments/new-instrument/form-fields/PenultimateFloaterSettlementDateField'
import { PriceTypeField } from '@/pages/instruments/new-instrument/form-fields/PriceTypeField'
import { QuoteFactorFormField } from '@/pages/instruments/new-instrument/form-fields/QuoteFactorFormField'
import { StructureNameField } from '@/pages/instruments/new-instrument/form-fields/StructureNameField'
import { SwapPaymentsYearlyField } from '@/pages/instruments/new-instrument/form-fields/SwapPaymentsYearlyField'
import { TradeIdField } from '@/pages/instruments/new-instrument/form-fields/TradeIdField'
import { UnitMultiplierFormField } from '@/pages/instruments/new-instrument/form-fields/UnitMultiplierFormField'
import { DiverOtcSchemaType } from '@/pages/instruments/new-instrument/schemas/diver-otc.schema'

export interface DiverOtcFormFieldsProps {}

export const DiverOtcFormFields: React.FC<DiverOtcFormFieldsProps> = ({}) => {
  const { trigger } = useFormContext<DiverOtcSchemaType>()

  useEffect(() => {
    trigger()
  }, [])

  return (
    <div className={'@container flex flex-col gap-4'}>
      <FormFieldRow>
        <StructureNameField />
        <UnderlyingInstrumentIdField />
        <FundIdField />
        <CurrencyIdField />
      </FormFieldRow>
      <FormFieldRow>
        <NotionalField />
        <CounterpartyIdField />
        <TradeIdField />
        <EffectiveDateFormField />
      </FormFieldRow>
      <FormFieldRow>
        <MaturityDateField />
        <FirstFloaterSettlementDateField />
        <PenultimateFloaterSettlementDateField />
        <CashSettlementDateField />
      </FormFieldRow>
      <FormFieldRow>
        <FundingInstrumentFormField />
        <LeverageField />
        <PriceTypeField />
        <FloaterSpreadBpsField />
      </FormFieldRow>
      <FormFieldRow>
        <SwapPaymentsYearlyField />
        <BucketIdField />
        <FundingReturnTypeField />
        <FundedReturnTypeField />
      </FormFieldRow>
      <FormFieldRow>
        <UnitMultiplierFormField />
        <QuoteFactorFormField />
      </FormFieldRow>
    </div>
  )
}

export interface UnderlyingInstrumentIdFieldProps {}

export const UnderlyingInstrumentIdField: React.FC<UnderlyingInstrumentIdFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{
    underlying_instrument_id: number
  }>()

  return (
    <FormField
      name="underlying_instrument_id"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Underlying Instrument ID</FormLabel>
              <FormError />
            </div>
            <InstrumentIdByTypeInput
              instrument_type_id={11}
              value={value?.toString()}
              setValue={(value) =>
                setValue('underlying_instrument_id', parseInt(value), {
                  shouldValidate: true,
                })
              }
              placeholder={'Select an underlying'}
            />
          </FormItem>
        )
      }}
    />
  )
}

export interface FundingInstrumentIdFieldProps {
  name?: string
}
